/*
 *   PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *    Copyright © 2017. Pearson Education, Inc.
 *    All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains
 *   the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *   herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *   patent applications, and are protected by trade secret or copyright law.
 *   Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *   is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 */
(function () {
	'use strict';
	// this function is strict...
}());

var SocketExperienceNamespace = SocketExperienceNamespace || {};
SocketExperienceNamespace.Controller = SocketExperienceNamespace.Controller || {};
SocketExperienceNamespace.Service = SocketExperienceNamespace.Service || {};
SocketExperienceNamespace.Adapter = SocketExperienceNamespace.Adapter || {};
SocketExperienceNamespace.Util = SocketExperienceNamespace.Util || {};

$(function () {
	SocketExperienceNamespace.Service.PearsonIconService && SocketExperienceNamespace.Service.PearsonIconService.loadPearsonIcons();
	executeFunction("init");
});

$(window).resize(function () {
	executeFunction("onWindowResize");
});

var executeFunction = function (functionName) {
	var dataModel = initializeModel();
	dataModel.forEach(function (data, component) {
		if (data.componentClientController) {
			var namespaceFunction = data.componentClientController + "." + functionName + "()";
			var executableFunction = new Function(namespaceFunction);
			executableFunction();
		}
	});
};
/*
 *   PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *    Copyright © 2017. Pearson Education, Inc.
 *    All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains
 *   the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *   herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *   patent applications, and are protected by trade secret or copyright law.
 *   Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *   is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 */
SocketExperienceNamespace.Controller.HeaderController = (function () {

	var myHelpDrawerContent = null;

	/** initialize the component when document is ready */
	var init = function () {
		setDefaultHelpDrawerContent();
		openHelpDrawer();
	};

	/** get the freemaker data model */
	var getDataModel = function () {
		var dataModel = initializeModel();
		return dataModel.get("headerComponent");
	};

	/** Open Help Drawer on click */
	var openHelpDrawer = function () {
		$('#btnHelpDrawer').on('keypress click', function (event) {
			var code = event.keyCode || event.which;
			if ((event.type === 'keypress' && code === 13) || event.type === 'click') {
				SocketExperienceNamespace.Service.HelpDrawerService.getHelpDrawer(myHelpDrawerContent).open();
			}
		});
	};

	/**
	 * If calling party want to override the helpDrawerContent then this method suppose to be called.
	 * given helpDrawerContent will be set to the myHelpDrawerContent.
	 *
	 * @param helpDrawerContent
     */
	var setHelpDrawerContent = function (helpDrawerContent) {
		myHelpDrawerContent = helpDrawerContent;
	};

	/**
	 * If myHelpDrawerContent does not hold any value then set the helpDrawerContent coming from the dataModel of the headerComponent.
     */
	var setDefaultHelpDrawerContent = function () {
		if (myHelpDrawerContent == null) {
			setHelpDrawerContent(getDataModel().helpDrawerContent);
		}
	};

	/** This will be called on window resize */
	var onWindowResize = function () {
	};

	return {
		"init": init,
		"onWindowResize": onWindowResize,
		"getDataModel": getDataModel,
		"setHelpDrawerContent": setHelpDrawerContent
	};
})();

/*
 *   PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *    Copyright © 2017. Pearson Education, Inc.
 *    All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains
 *   the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *   herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *   patent applications, and are protected by trade secret or copyright law.
 *   Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *   is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 */
SocketExperienceNamespace.Controller.SocketErrorController = (function () {

	var $launchContextId = null;

	var $resultArray = null;
	var browserName = "";
    var fullVersion = "";
    var userIds = "User ID";
    var launchgenerations = "Launch Generation";
    var customPearsonUrn = "Custom Pearson Product Urn";
    var customOptNames = "Custom Opt Name";
    var cpgRoles = "Roles";
    var channelPartnerNames = "Channel Partner Name";
    var insTitleClientDevice = "Device";
    var insTitleInternetBrowserInfo = "Internet Browser";
    var insTitleClientOS = "Client OS";
    var organizationIdTitle = "Organization ID";
    var productModelTypeTitle = "Product Model Type";
    var lmsCourseRole = "Course Role";
    var lmsCourseId = "LMS Course ID";
    var InternalCourseId = "Pearson Course ID";
    var pearsonRevelCourseKeyTitle = "Pearson Course Key";
    var lmsUserIdTitle = "LMS User ID";
    var pearsonUserIdTitle = "Pearson User ID";
    var socketErrorCode = "Error Code";
    var insTitleHeading = "Launch Type";
    var hideErrorDiagnostics = false;

	/** initialize the component when document is ready */
	var init = function () {
		isPiInitialized = false
		setIdamBaseUrl();
		setErrorCode();
		setErrorMessage();
		showHideDiagnostics();
		initTabKeyFunctionForModal();
		initSigninDirectlyToRevel();
		if(getErrorDataModel()!== null && getErrorDataModel().launchContext !== undefined) {
			initializeToken(getErrorDataModel());
		}
		initializePendoOnSocketErrorContentComponentController();
	};

	setIdamBaseUrl = function () {
		var idamBaseUrl = getErrorDataModel().idamBaseUrl;
		$("#idamBaseUrl").text(idamBaseUrl);
	}

	/**
	 * Set the relevant error code.
	 */
	var setErrorCode = function () {
		var errorCode = getErrorDataModel().errorCode;
		$("#errorCode").text(errorCode);
		$("#diagnosticErrorCode").text(errorCode);
	};

	var setCourseInfo = function (result) {
		 $resultArray = result;
        // var insTitle = ;
       
        if(result.external === undefined || result.external == null || result.external.launch_route == "login"){  
            document.getElementById("insTitleListID").remove();
            document.getElementById("userInformationSection").remove();
            document.getElementById("courseInformationSection").remove();
            document.getElementById("integrationInformationSection").remove();
            document.getElementById("organizationalDataSection").remove();
            document.getElementById("cpgDataInformation").remove();
           
        }else {  
            console.log(result.external);
            $("#insTitle").text(result.external.lti_version);
            $("#pearsonUserId").text(result.external.internal_user_id);
            $("#lmsUserId").text(result.external.external_system_user_id);
            $("#pearsonRevelCourseKey").text(result.external.internal_course_id);
            $("#contextTitle").text(result.external.context_title);
            $("#lmsCourseId").text(result.external.external_system_course_id);
            $("#lmsCourseRole").text(result.external.roles);
            $("#coursePairedStatus").text(result.external.is_course_paired);
            $("#organizationId").text(result.external.organization);
            $("#diagnosticErrorCode").text(result.external.error_code);
            $("#consumerCode").text(result.external.tool_consumer_info_product_family_code);
            $("#version").text(result.external.tool_consumer_info_version);
            $("#institutionCode").text(result.external.tool_consumer_instance_name);
			$("#remove-course-courseName").text(result.external.external_system_course_name);

            if (result.external.cpgData === undefined) {
                const element = document.getElementById("cpgDataInformation");
                element.remove();
            }else {
                if(result.external.cpgData.custom_channel_partner_name === undefined){
                    $("#channelPartnerName").text(result.external.cpgData.custom_channel_partner_name);
                }else{
                    $("#channelPartnerName").text(result.external.custom_channel_partner_name);
                }
                
                $("#cpgRole").text(result.external.cpgData.roles);
                $("#customOptName").text(result.external.cpgData.custom_opt_name);
                $("#customPearsonProductUrn").text(result.external.cpgData.custom_pearson_product_urn);
                $("#launchGeneration").text(result.external.cpgData.launch_generation);
                $("#userId").text(result.external.cpgData.user_id);
            }
           
        }

        $("#timeStamp").text(getTimeStamp);
		$("#insClientOS").text(getOSName);
        $("#insInternetBrowser").text(getInternetBrowser);
        $("#insBrowserFullVersion").text(getBrowserFullVersion);
        $("#insClientDevice").text(getClientDeviceType);

	};

	function getOSName() {

        var osName = "";

        if (navigator.appVersion.indexOf("Win") !== -1) {
            osName = "Windows";
        } else if (navigator.appVersion.indexOf("Mac") !== -1) {
            osName = "MacOS";
        } else if (navigator.appVersion.indexOf("Linux") !== -1) {
            osName = "Linux";
        } else if (navigator.appVersion.indexOf("X11") !== -1) {
            osName = "UNIX";
        }
        return osName;
    }

	function getInternetBrowser() {
        getBrowserAndVersion();
        return browserName;
    }

	function getBrowserFullVersion() {
        getBrowserAndVersion();
        return fullVersion;
    }

	function getClientDeviceType() {
        if (navigator.userAgent.match(/mobile/i)) {
            return 'Mobile';
        } else if (navigator.userAgent.match(/iPad|Android|Touch/i)) {
            return 'Tablet';
        } else {
            return 'Desktop';
        }
    }

	function getBrowserAndVersion() {
        var nameOffset, ix, nAgt, verOffset, browserNameTexts, browserNames, indexOfBrowser;

        nAgt = navigator.userAgent;
        browserName = navigator.appName;
        fullVersion = parseFloat(navigator.appVersion);

        browserNameTexts = ["Firefox", "Safari", "Chrome", "Opera", "OPR/", "MSIE", "Trident"];
        browserNames = ["Firefox", "Safari", "Chrome", "Opera", "Opera", "Internet Explorer", "Internet Explorer"];

        $.each(browserNameTexts, function (index, value) {
            if (nAgt.indexOf(value) !== -1) {
                browserName = browserNames[index];
                indexOfBrowser = index;
                verOffset = nAgt.indexOf(value);
            }
        });

        // Get browser fullVersion according to the index of browser
        switch (indexOfBrowser) {
            case 0:
                fullVersion = nAgt.substring(verOffset + 8);
                break;
            case 1:
                if ((verOffset = nAgt.indexOf("Version")) !== -1) {
                    fullVersion = nAgt.substring(verOffset + 8);
                } else {
                    fullVersion = nAgt.substring(verOffset + 7);
                }
                break;
            case 2:
                fullVersion = nAgt.substring(verOffset + 7);
                break;
            case 3:
                if ((verOffset = nAgt.indexOf("Version")) !== -1) {
                    fullVersion = nAgt.substring(verOffset + 8);
                } else {
                    fullVersion = nAgt.substring(verOffset + 6);
                }
                break;
            case 4:
                fullVersion = nAgt.substring(verOffset + 4);
                break;
            case 5:
                fullVersion = nAgt.substring(verOffset + 5);
                break;
            case 6:
                verOffset = nAgt.indexOf("rv");
                fullVersion = nAgt.substring(verOffset + 3);
                break;
            case 7:
                if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
                    browserName = nAgt.substring(nameOffset, verOffset);
                    fullVersion = nAgt.substring(verOffset + 1);
                }
                break;
            default:
                break;
        }

        // Trim the browser fullVersion string at semicolon/space/brackets if present
        if ((ix = fullVersion.indexOf(";")) !== -1) {
            fullVersion = fullVersion.substring(0, ix);
        }
        if ((ix = fullVersion.indexOf(" ")) !== -1) {
            fullVersion = fullVersion.substring(0, ix);
        }
        if ((ix = fullVersion.indexOf(")")) !== -1) {
            fullVersion = fullVersion.substring(0, ix);
        }
    }

	var getTimeStamp = function () {
        return new Date($.now());
    };

	var setErrorMessage = function () {
		var errorMessage = getErrorDataModel().errorMessage;
		var errorHeader = getErrorDataModel().errorMessageHeader;
		if (errorMessage != null || errorMessage != undefined) {
			$("#errorMessageSection").html(errorMessage);
		}
		if (errorHeader != null || errorHeader != undefined) {
			$("#errorHeader").text(errorHeader);
		}

	};

	/** get the FREEMARKER data model */
	var getErrorDataModel = function () {
		var dataModel = initializeModel();
		return dataModel.get("socketErrorContentComponent");
	};


	/** This will be called on window resize */
	var onWindowResize = function () {
	};

    var showHideDiagnostics =  function() {
        hideErrorDiagnostics = getErrorDataModel().hideErrorDiagnostics !== undefined ? getErrorDataModel().hideErrorDiagnostics : false;

        if(hideErrorDiagnostics) {
            $('#diagnosticsLink').parent().remove();
        }
    }

	$('#diagnosticsLink').click(function(event){
		event.preventDefault();
		        $("#divRevelCourseAssociation").hide();
				var launchContext = window.location.href.split("err?key=");
				var launchContextToken = launchContext[1];
				$launchContextId = launchContextToken;
				$("#diagnosticContextToken").text(launchContextToken);
				var url = getErrorDataModel().baseUrl + 'launchDetails/context/' + launchContextToken;

            $.ajax({
                url: url,
                type: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
                dataType: 'json',
                cache: false,
                success: function (result) {

					setCourseInfo(result);
					$("#socketErrorContentComponent").show("courseDisassociationMsg");
					checkInstructorandErrorCodeOnDiagnosticClick(result);
                },
                error: function () {
					alert("Failed!");
                }
            });

	});
	function checkInstructorandErrorCodeOnDiagnosticClick(result) {

		var errorCodeToDisplayRemoveLink = '';
		var role ='';
		var errorCodeArr = '';

		if (getErrorDataModel() !== undefined) {
			if (getErrorDataModel().errorCode !== undefined) {
				errorCodeToDisplayRemoveLink = getErrorDataModel().errorCode;
			}
			if (getErrorDataModel().errorCodesForUnpair !== undefined) {
				errorCodeArr = getErrorDataModel().errorCodesForUnpair;
			}
		}
		if (getErrorDataModel().launchContext !== undefined && getErrorDataModel().launchContext.external !== undefined) {
			role = getErrorDataModel().launchContext.external.external_system_user_role;
		}

		if (errorCodeToDisplayRemoveLink !== '' && errorCodeToDisplayRemoveLink !== undefined) {
			if (errorCodeArr !== '' && errorCodeArr !== undefined) {
				if (errorCodeArr.includes(errorCodeToDisplayRemoveLink)) {
					if (role !== '' && (role.toLowerCase().includes("instructor") || role.toLowerCase().includes("teacher"))) {
						$("#divRevelCourseAssociation").show();
					} else {
						$("#divRevelCourseAssociation").hide();
					}
				} else {
					$("#divRevelCourseAssociation").hide();
				}
			} else {
				$("#divRevelCourseAssociation").hide();
			}
		} else {
			$("#divRevelCourseAssociation").hide();
		}
	}
	$('#revelCourseAssociationLink').click(function (event) {
		event.preventDefault();
		$("#socketErrorContentComponent").show("courseDisassociationMsg");
	});



	$("#btnInsDownloadDiagnostic").click(function(event) {

		event.preventDefault();
		getDiagnostic(getErrorDataModel(), constructDiagnosticContent(), "_self");



	});

	function getDiagnostic(dataModel, diagnosticPayload, formTarget) {

		// Construct the URL
		var url = dataModel.baseUrl + 'dashboard/download/diagnostic/'+$launchContextId;

		// Construct the form
		var form = $('<form/>', {
			action: url,
			method: 'POST',
			target: formTarget
		}).appendTo(document.body);

		// Construct the pay Load
		var payload = $('<input/>', {
			type: 'hidden',
			name: 'payload'
		}).appendTo(form);
		payload.val(JSON.stringify(diagnosticPayload));
		// Submit the form
		form.submit();

	}

	var getMetadata = function () {
        var jsonObject =
        {
            "contextKey":$launchContextId
        };

        return jsonObject;
    };


	var constructDiagnosticContent = function () {

        if($resultArray.external != undefined || $resultArray.external != null){
            var diagnosticContent = {
                "metadata": getMetadata(),
                "payload": [
                    getComponents(1, $("#diagnosticsInformation"), 1, getDiagnosticsInformation()),
                    getComponents(2, $("#userInformation"), 2, getUserInformation()),
                    getComponents(3, $("#courseInformation"), 3, getCourseInformation()),
                    getComponents(4, $("#organizationalData"), 4, getOrganizationalData()),
                    getComponents(5, $("#insClientInformation"), 5, getClientInformation())
    
                ]
            };
        }else{
            var diagnosticContent = {
                "metadata": getMetadata(),
                "payload": [
                    getComponents(1, $("#diagnosticsInformation"), 1, getDiagnosticsInformationExternalNull()),
                    getComponents(2, $("#insClientInformation"), 2, getClientInformation())
    
                ]
            };
        }

        

        if($resultArray.external != undefined || $resultArray.external != null){

            if($resultArray.external.cpgData != undefined){
                diagnosticContent.payload.push(getComponents(6, $("#cpgData"), 6, getCpgData()));
            }
        }

        return diagnosticContent;
    };

	var getComponents = function (infoComponentId, infoHeadingTitle, order, subComponentInfo) {
        var jsonObject =
        {
            "infoComponentId": infoComponentId,
            "infoHeading": infoHeadingTitle.text(),
            "order": order,
            "infoSubComponents": subComponentInfo
        };

        return jsonObject;
    };

	var getDiagnosticsInformation = function () {

        var jsonObject =
            [
                constructJsonObject(insTitleHeading, $("#insTitle").text()),
                constructJsonObject(socketErrorCode, $("#diagnosticErrorCode").text())
            ];

        return jsonObject;
    };

    var getDiagnosticsInformationExternalNull = function () {

        var jsonObject =
            [
                constructJsonObject(socketErrorCode, $("#diagnosticErrorCode").text())
            ];

        return jsonObject;
    };

	var getUserInformation = function () {
        var jsonObject =
            [
                constructJsonObject(pearsonUserIdTitle, $("#pearsonUserId").text()),
                constructJsonObject(lmsUserIdTitle, $("#lmsUserId").text())
            ];

        return jsonObject;
    };

	var getCourseInformation = function () {
        var jsonObject =
            [
                constructJsonObject(pearsonRevelCourseKeyTitle, $("#contextTitle").text()),
                constructJsonObject(InternalCourseId.replace(/\s/g, ' '), $("#pearsonRevelCourseKey").text()),
                constructJsonObject(lmsCourseId.replace(/\s/g, ' '), $("#lmsCourseId").text()),
                constructJsonObject(lmsCourseRole.replace(/\s/g, ' '), $("#lmsCourseRole").text()),
                constructJsonObject(productModelTypeTitle, $("#coursePairedStatus").text())

            ];

        return jsonObject;
    };

	var getOrganizationalData = function () {
        var jsonObject =
            [

                constructJsonObject(organizationIdTitle, $("#organizationId").text())
            ];

        return jsonObject;
    };

	var getClientInformation = function () {
        var jsonObject =
            [
                constructJsonObject(insTitleClientOS, $("#insClientOS").text()),
                constructJsonObject(insTitleInternetBrowserInfo, $("#insInternetBrowserInfo").text().replace(/\s/g, ' ')),
                constructJsonObject(insTitleClientDevice, $("#insClientDevice").text())

            ];

        return jsonObject;
    };

	var getCpgData = function () {
        var jsonObject =
            [
                constructJsonObject(channelPartnerNames, $("#channelPartnerName").text()),
                constructJsonObject(cpgRoles.replace(/\s/g, ' '), $("#cpgRole").text()),
                constructJsonObject(customOptNames.replace(/\s/g, ' '), $("#customOptName").text()),
				constructJsonObject(customPearsonUrn.replace(/\s/g, ' '), $("#customPearsonProductUrn").text()),
				constructJsonObject(launchgenerations.replace(/\s/g, ' '), $("#launchGeneration").text()),
                constructJsonObject(userIds, $("#userId").text())

            ];

        return jsonObject;
    };


	var constructJsonObject = function (labelName, labelValue) {
        var jsonObject =
        {
            "labelName": labelName,
            "labelValue": labelValue
        };
        return jsonObject;
    };

	var $revelCourseAssociationLink = $("#revelCourseAssociationLink");
	var $courseDisassociationMsg = $("#courseDisassociationMsg");
	var $divDisassociationConfirmation = $("#divDisassociationConfirmation");
	var $divDisassociationSuccessFromError = $("#divDisassociationSuccessFromError");
	var $btnRemoveRevelAssociation = $("#btnRemoveRevelAssociation");
	var $btnDismissDisassociationConfirmationModal = $("#btnDismissDisassociationConfirmationModal");
	var $btnReturnToErrorPageOnFailure = $("#btnReturnToErrorPageOnFailure");
	var $btnReturnToErrorPageOnSuccess = $("#btnReturnToErrorPageOnSuccess");
	var $btnReturnNoInternalUser = $("#btnReturnNoInternalUser");


	/** Close button of the Dissociation success dialog which shows after course dissociation completed. */
	var $btnCloseDissociationSuccessModal = $("#btnDismissDisassociationSuccessModal");
	/** Return to course button of the Dissociation success dialog. */
	var $btnReturnToCourse = $("#btnReturnToRevelCourse");

	var DESIRE_2_LEARN = 'Desire2learn';

	/** Focus on 'Cancel' button upon modal display */
	$courseDisassociationMsg.on('shown.bs.modal', function () {
		if ($("div[id='divNoInternalUserOnLaunch']").css("display") == 'block') {
			$("#btnReturnNoInternalUser").focus();
		} else {
			$('#cancelDisassociation').focus();
		}

	});

	/** Focus caller on modal hide */
	$courseDisassociationMsg.on('hidden.bs.modal', function () {
		$revelCourseAssociationLink.focus();
	});

	/**
	 * @description prevent default click action and show Disassociation Confirmation on revel Course Association Link click or key press
	 *
	 * @param  {element} $revelCourseAssociationLink
	 * @param  {event} event
	 * @param  {element} $divDisassociationConfirmation
	 * @param  {element} $divDisassociationSuccessFromError
	 * @param  {modal} courseDisassociationMsg
	 */
	$revelCourseAssociationLink.click(function (event) {
		event.preventDefault();
		// View close button
		$btnDismissDisassociationConfirmationModal.removeClass("component-hidden");
		$btnCloseDissociationSuccessModal.addClass("component-hidden");
		if (getErrorDataModel().launchContext!== undefined && getErrorDataModel().launchContext.external.internal_user_id !== undefined) {
			//View disassociation
			$divDisassociationConfirmation.removeClass("component-hidden");
			$divDisassociationSuccessFromError.addClass("component-hidden");
			$("#divNoInternalUserOnLaunch").addClass("component-hidden");
			$("#divDisassociationSuccessFromError").addClass("component-hidden");
			$("div[id='divDisassociationConfirmation']").css("display", "block");
			$("div[id='divNoInternalUserOnLaunch']").css("display", "none");
			$("div[id='divDisassociationFailureFromError']").css("display", "none");
			$("div[id='divDisassociationFailureWithNoErrCode']").css("display", "none");
			$("div[id='divDisassociationSuccessFromError']").css("display", "none");
		} else{
			showNoInternalUserMessage()
		}
		$courseDisassociationMsg.modal({
			backdrop: 'static',
			show: true
		});
	});

	/** 'Yes, Remove' button click - show modal and button action */
	$btnRemoveRevelAssociation.click(function () {

		$btnCloseDissociationSuccessModal.removeClass("component-hidden");
		$btnDismissDisassociationConfirmationModal.addClass("component-hidden");
       	//Dissociate the course
		dissociateCourse(getErrorDataModel(), showDissociateSuccessMessage);
	});


	/** Signing to REVEL upon clicking Link in course disassociation modal */
	var initSigninDirectlyToRevel = function () {
		$('#signinDirectlyToRevel, #signinDirectlyToRevelSuccess').on('keypress click', function (event) {
			var code = event.keyCode || event.which;
			if ((event.type === 'keypress' && code === 13) || event.type === 'click') {
				event.preventDefault();
				window.open(getErrorDataModel().pearsonConsoleSigninUrl, '_blank');
			}
		});
	};

	var initTabKeyFunctionForModal = function () {
		$btnRemoveRevelAssociation.keydown(function (e) {
			if ($btnRemoveRevelAssociation.is(":focus") && (e.which || e.keyCode) == 9) {
				e.preventDefault();
				$btnDismissDisassociationConfirmationModal.focus();
			}
		});
		$btnReturnToCourse.keydown(function (e) {
			if ($btnReturnToCourse.is(":focus") && (e.which || e.keyCode) == 9) {
				e.preventDefault();
				$btnCloseDissociationSuccessModal.focus();
			}
		});
	};


	/** Show the Dissociation success dialog if the course dissociation is success. */
	var showDissociateSuccessMessage = function () {
		$divDisassociationSuccessFromError.removeClass("component-hidden");
		$divDisassociationConfirmation.addClass("component-hidden");
		$("div[id='divDisassociationConfirmation']").css("display", "none");
		$("div[id='divNoInternalUserOnLaunch']").css("display", "none");
		$("div[id='divDisassociationFailureFromError']").css("display", "none");
		$("div[id='divDisassociationFailureWithNoErrCode']").css("display", "none");
		$("div[id='divDisassociationSuccessFromError']").css("display", "block");
		$("#btnReturnToErrorPageOnSuccess").focus();
	};


	/** This will be called on window resize */
	var onWindowResize = function () {
	};
	/**
		 * Required information will be taken from the dataModel and send to the Server to perform the course
		 * dissociation logic.
		 * @param dataModel
		 */
	var dissociateCourse = function (dataModel, successCallback) {
		getToken(dataModel);
	};

	/**
	 * @desc Initialize the PI Session
	 * @param dataModel The data model
	 */
	function initializeToken(dataModel) {

		// Check whether PI session is initialized and launch context has PiId
		if (!isPiInitialized && (dataModel.launchContext.external.internal_user_id !== undefined)) {

			try {

				// Initialize the PI session
				piSession.initialize(dataModel.clientId, { useJwt: true });
				// Initialize the logout event
				piSession.on(piSession.LogoutEvent, piLogoutEvent);

				// Set the PI initialized property
				isPiInitialized = true;

			} catch (err) {
				console.log("pi initialization failed");
			}
		} else {
			showNoInternalUserMessage();
		}
	}
	function showNoInternalUserMessage() {
		$("#divDisassociationConfirmation").addClass("component-hidden");
		$("#divDisassociationSuccessFromError").addClass("component-hidden");
		$("#divNoInternalUserOnLaunch").removeClass("component-hidden");
		$("#divDisassociationConfirmation").css("display", "none");
		$("div[id='divNoInternalUserOnLaunch']").css("display", "block");
		$("#noSessionError").text("SOCKET_LS_150");
		$("#btnReturnNoInternalUser").focus();
	}
	/**
 * Listen to the PI logout event.
 */
	function piLogoutEvent() {
		console.log("In piLogoutEvent ");
		SocketExperienceNamespace.Adapter.UiRedirectAdapter.redirectToSessionEndPage(encodeURIComponent('pi-adapter.js'), baseUrl);
	}

	function login() {
		try {
			piSession.login(window.location.href, 2, getToken);
		} catch (err) {
			console.log(err);
		}
	}

	function getInt(val, dflt) {
		var intVal = parseInt(val);
		if (isNaN(intVal))
			return dflt;
		return intVal;
	}
	function getToken() {
		try {
			var minLifetime = 10;
			var timeout = 10;
			piSession.getToken(getTokenCallback, getInt(minLifetime, 0), getInt(timeout, 0));
		} catch (err) {
			console.log(err);
		}

	}
	function removeCourseAssociation(userToken) {
		var errorDataModel = getErrorDataModel();
		var contextKey = errorDataModel.launchContext.integrationKeys.launchContextToken;
		var associationId = errorDataModel.launchContext.integrationKeys.associationId;
		var externalCourseId = errorDataModel.launchContext.external.external_system_course_id;
		var url = errorDataModel.baseUrl + 'course/dissociate';

		$.ajax({
			url: url,
			type: 'PUT',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'x-Authorization': userToken
			},
			dataType: 'json',
			data: JSON.stringify({
				'contextKey': contextKey,
				'associationId': associationId,
				'externalCourseId': externalCourseId
			}),
			cache: false,
			success: function (result) {
				console.log(result);
				showDissociateSuccessMessage();
			},
			error: function (xhr, textStatus, errorThrown) {
				$("#divDisassociationConfirmation").hide();
				if (xhr.responseJSON.errorCode !== undefined && xhr.responseJSON.errorCode !== null && xhr.responseJSON.errorCode !== "") {
					$("#divDisassociationFailureFromError").show();
					$('#errorcoderes').text(xhr.responseJSON.errorCode);
					$("#btnReturnToErrorPageOnFailure").focus();
					noFocusOutsideModal($courseDisassociationMsg, $btnDismissDisassociationSuccessModal, $btnReturnToErrorPageOnFailure);
				} else {
					$("#divDisassociationFailureWithNoErrCode").show();
					$("#btnReturnToErrorPageOnFailureWithNoCode").focus();
					noFocusOutsideModal($courseDisassociationMsg, $btnDismissDisassociationSuccessModal, $btnReturnToErrorPageOnFailureWithNoCode);

				}
			}
		});
	};

	$('#btnReturnToErrorPageOnSuccess').click(function (event) {
		event.preventDefault();
		$("#divDisassociationSuccessFromError").hide();
		$("#divRevelCourseAssociation").hide();
	});
	$('#btnDismissDisassociationConfirmationModal').click(function (event) {
		event.preventDefault();
		if ($("div[id='divDisassociationSuccessFromError']").css("display") == 'block') {
			$("#divRevelCourseAssociation").hide();
		}
		if ($("div[id='divNoInternalUserOnLaunch']").css("display") == 'block') {
			$("#divRevelCourseAssociation").hide();
		}
	});
	$('#btnDismissDisassociationSuccessModal').click(function (event) {
		event.preventDefault();
		if ($("div[id='divDisassociationSuccessFromError']").css("display") == 'block') {
			$("#divRevelCourseAssociation").hide();
		}
	});
	$('#btnReturnToErrorPageOnFailure').click(function (event) {
		event.preventDefault();
		$("#divDisassociationFailureFromError").hide();
	});
	$('#btnReturnToErrorPageOnFailureWithNoCode').click(function (event) {
		event.preventDefault();
		$("#divDisassociationFailureWithNoErrCode").hide();
	});
	$('#btnReturnNoInternalUser').click(function (event) {
		event.preventDefault();
		$("#divNoInternalUserOnLaunch").hide();
		$("#divRevelCourseAssociation").hide();
	});
	function getTokenCallback(status, token, dataModel) {
		if (status.toLowerCase() == "success") {
			removeCourseAssociation(token);
		}
		else {
			if (status.toLowerCase() == "notoken" || status.toLowerCase() == "nosession") {
				console.log("status:" + status);
				login();
			}
		}
	}

	function initializePendoOnSocketErrorContentComponentController() {
		SocketExperienceNamespace.Adapter.PendoAnalyticsAdapter.initializePendo(getErrorDataModel, true);
	}

	return {
		"init": init,
		"onWindowResize": onWindowResize,
		"dissociateCourse": dissociateCourse
	};
})();

/*
 *   PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *    Copyright © 2017. Pearson Education, Inc.
 *    All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains
 *   the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *   herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *   patent applications, and are protected by trade secret or copyright law.
 *   Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *   is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 */
SocketExperienceNamespace.Service.PearsonIconService = (function () {

    /** Loads the PEARSON icon sprite into the DOM */
    var loadPearsonIcons = function () {
        if (!$("#pe-icons-sprite").length) {
        	var path;
        	if(isFromCdn !== true) {
				path = "../../uiservice/build/16.17.0/lib/node_modules/pearson-elements/dist/icons/p-icons-sprite-1.1.svg"
			}else{
				path= static_assets+"lib/node_modules/pearson-elements/dist/icons/p-icons-sprite-1.1.svg";
			}
	            $.get(path, function (data) {
	                $('body').prepend($(new XMLSerializer().serializeToString(data.documentElement)));
	            });

        }
    };


    return {
        "loadPearsonIcons": loadPearsonIcons
    };
})();

/*
 *   PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *    Copyright © 2017. Pearson Education, Inc.
 *    All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains
 *   the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *   herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *   patent applications, and are protected by trade secret or copyright law.
 *   Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *   is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 */
SocketExperienceNamespace.Service.HelpDrawerService = (function ($) {

	/** Get and Populate the help drawer content */
	var getHelpDrawer = function (helpDrawerContents) {

		var evt, help;
		var helpTopics = [];

		document.dispatchEvent(new CustomEvent('o.InitContextualHelp'));

		/** adding a list of help topics to display | values are derived from the path of the files at https://github.com/Pearson-Higher-Ed/help-content in the /out directory without the language code */
		for (var key in helpDrawerContents) {
			if (helpDrawerContents.hasOwnProperty(key)) {
				helpTopics.push(helpDrawerContents[key]);
			}
		}

		/**  to access the 'o-contextual-help-drawer' after it's initialized  */
		help = document.getElementById('o-contextual-help-drawer').oContextualHelp;

		$(document).on('click', '#o-contextual-help-drawer h3 a', function (evt) {
			evt.preventDefault();
		});

		/** Bring 'Help Topics' text inline with close icon */
		$(".o-contextual-help__header").children("h2").attr("style", "display: inline;");
		/** Making 'Close Help' text visible */
		$(".o-contextual-help__header").children("button").children("span").removeClass("pe-sr-only");
		/** Appending close icon to 'Close Help' */
		$(".o-contextual-help__header").children("button").children("i").addClass("glyphicon glyphicon-remove helpdrawer-icon");
		/** Appending left icon in 'Back to the topics' */
		$("#contextual-help-close-content").children("span").children("i").addClass("glyphicon glyphicon-chevron-left helpdrawer-icon");

		help.removeAllTopics();
		help.addTopics(helpTopics);

		return help;
	};

	return {
		"getHelpDrawer": getHelpDrawer
	};
})(jQuery);

!function(e){function t(r){if(o[r])return o[r].exports;var n=o[r]={exports:{},id:r,loaded:!1};return e[r].call(n.exports,n,n.exports,t),n.loaded=!0,n.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){e.exports=o(3)},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var o=this[t];o[2]?e.push("@media "+o[2]+"{"+o[1]+"}"):e.push(o[1])}return e.join("")},e.i=function(t,o){"string"==typeof t&&(t=[[null,t,""]]);for(var r={},n=0;n<this.length;n++){var i=this[n][0];"number"==typeof i&&(r[i]=!0)}for(n=0;n<t.length;n++){var a=t[n];"number"==typeof a[0]&&r[a[0]]||(o&&!a[2]?a[2]=o:o&&(a[2]="("+a[2]+") and ("+o+")"),e.push(a))}},e}},function(e,t,o){function r(e,t){for(var o=0;o<e.length;o++){var r=e[o],n=d[r.id];if(n){n.refs++;for(var i=0;i<n.parts.length;i++)n.parts[i](r.parts[i]);for(;i<r.parts.length;i++)n.parts.push(c(r.parts[i],t))}else{for(var a=[],i=0;i<r.parts.length;i++)a.push(c(r.parts[i],t));d[r.id]={id:r.id,refs:1,parts:a}}}}function n(e){for(var t=[],o={},r=0;r<e.length;r++){var n=e[r],i=n[0],a=n[1],s=n[2],l=n[3],c={css:a,media:s,sourceMap:l};o[i]?o[i].parts.push(c):t.push(o[i]={id:i,parts:[c]})}return t}function i(e,t){var o=v(),r=y[y.length-1];if("top"===e.insertAt)r?r.nextSibling?o.insertBefore(t,r.nextSibling):o.appendChild(t):o.insertBefore(t,o.firstChild),y.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");o.appendChild(t)}}function a(e){e.parentNode.removeChild(e);var t=y.indexOf(e);t>=0&&y.splice(t,1)}function s(e){var t=document.createElement("style");return t.type="text/css",i(e,t),t}function l(e){var t=document.createElement("link");return t.rel="stylesheet",i(e,t),t}function c(e,t){var o,r,n;if(t.singleton){var i=w++;o=m||(m=s(t)),r=p.bind(null,o,i,!1),n=p.bind(null,o,i,!0)}else e.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(o=l(t),r=h.bind(null,o),n=function(){a(o),o.href&&URL.revokeObjectURL(o.href)}):(o=s(t),r=u.bind(null,o),n=function(){a(o)});return r(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;r(e=t)}else n()}}function p(e,t,o,r){var n=o?"":r.css;if(e.styleSheet)e.styleSheet.cssText=x(t,n);else{var i=document.createTextNode(n),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(i,a[t]):e.appendChild(i)}}function u(e,t){var o=t.css,r=t.media;if(r&&e.setAttribute("media",r),e.styleSheet)e.styleSheet.cssText=o;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(o))}}function h(e,t){var o=t.css,r=t.sourceMap;r&&(o+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var n=new Blob([o],{type:"text/css"}),i=e.href;e.href=URL.createObjectURL(n),i&&URL.revokeObjectURL(i)}var d={},f=function(e){var t;return function(){return"undefined"==typeof t&&(t=e.apply(this,arguments)),t}},g=f(function(){return/msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase())}),v=f(function(){return document.head||document.getElementsByTagName("head")[0]}),m=null,w=0,y=[];e.exports=function(e,t){t=t||{},"undefined"==typeof t.singleton&&(t.singleton=g()),"undefined"==typeof t.insertAt&&(t.insertAt="bottom");var o=n(e);return r(o,t),function(e){for(var i=[],a=0;a<o.length;a++){var s=o[a],l=d[s.id];l.refs--,i.push(l)}if(e){var c=n(e);r(c,t)}for(var a=0;a<i.length;a++){var l=i[a];if(0===l.refs){for(var p=0;p<l.parts.length;p++)l.parts[p]();delete d[l.id]}}}};var x=function(){var e=[];return function(t,o){return e[t]=o,e.filter(Boolean).join("\n")}}()},function(e,t,o){"use strict";o(15);var r=o(17),n=o(4),i=function(){document.removeEventListener("o.InitContextualHelp",i);var e=document.createElement("div");e.id="o-contextual-help-drawer",e.setAttribute("data-o-component","o-drawer"),e.classList.add("o-drawer-right","o-drawer-animated","o-contextual-help__drawer");var t=document.getElementsByTagName("body")[0],o=document.querySelector("header.o-app-header")||t.firstChild;t.insertBefore(e,o?o.nextSibling:o);var a=new r(e),s=new n(e);a.open=function(){s.open()},a.close=function(){s.close()},a.toggle=function(){s.toggle()},a._drawer=s};document.addEventListener("o.InitContextualHelp",i),r.init=i,e.exports=r},function(e,t,o){"use strict";o(16);var r=o(5),n=function(){r.init(),document.removeEventListener("o.InitAllDrawerElements",n)};document.addEventListener("o.InitAllDrawerElements",n),e.exports=r},function(e,t,o){"use strict";function r(e){if(!(this instanceof r))throw new TypeError("Constructor Drawer requires 'new'");if(!e)throw new TypeError("missing required argument: element");"string"==typeof e&&(e=document.querySelector(e)),this.target=e,this.currentTarget=!1,this.trigger,this.closeButton,this.target.style.display="none",this.target.classList.add("o-drawer"),this.trap=document.createElement("button"),this.trap.className="pe-trap",this.trap.onclick=function(e){e.preventDefault()},r.cache.set(e,this);var t=this.target.classList.contains("o-drawer-left")||this.target.classList.contains("o-drawer-right");if(t||this.target.classList.add("o-drawer-left"),!r.delegate){var o=new u(document.body);o.on("click",'[data-toggle="o-drawer"], [data-close="o-drawer"], [data-open="o-drawer"]',function(e,t){s(e,t,r)}),r.delegate=o}var n=this;return l(n),c(n),this}function n(e){return e||(e=document.body),e instanceof HTMLElement||(e=document.querySelectorAll(e)[0]),e.querySelectorAll('[data-o-component="o-drawer"]')}function i(e,t,o){e.classList.add("o-drawer-open"),t&&t.setAttribute("aria-expanded","true"),o&&o.focus()}function a(e,t){for(;(e=e.parentNode)&&e!==t;);return e}function s(e,t,o){e.preventDefault();for(var r=t.getAttribute("data-target")||t.getAttribute("href"),n=document.querySelectorAll(r),i=0,a=n.length;i<a;i++){var s=n[i],l=o.cache.get(s);if(l||"o-collapse"!==s.getAttribute("data-o-component")||(l=new o(s)),l){var c=p(t);l[c]()}}}function l(e){e.focusables=Array.prototype.slice.call(e.target.querySelectorAll('[tabindex="0"], a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])'));for(var t=0,o=e.focusables.length;t<o;t++){var r=e.focusables[t];if(r.hasAttribute("data-close")){e.closeButton=r;break}}e.focusables.length&&(e.firstFocusable=e.closeButton||e.focusables[0],e.target.appendChild(e.trap))}function c(e){document.addEventListener("o.Drawer.RightDrawer",function(){e.target.classList.contains("o-drawer-right")&&!e.currentTarget&&e.close(),e.currentTarget=!1}),document.addEventListener("o.Drawer.LeftDrawer",function(){e.target.classList.contains("o-drawer-left")&&!e.currentTarget&&e.close(),e.currentTarget=!1})}function p(e){if(e&&e.dataset)return Object.keys(e.dataset).filter(function(t){if("o-drawer"===e.dataset[t])return t})}var u=o(11),h=o(6),d=function(e,t,o){if(document.createEvent&&e.dispatchEvent){var r=document.createEvent("Event");r.initEvent(t,!0,!0),o&&(r.detail=o),e.dispatchEvent(r)}};r.cache=new h,r.init=function(e){for(var t=n(e),o=[],i=0,a=t.length;i<a;i++)o.push(new r(t[i]));return o},r.destroy=function(){r.bodyDelegate&&r.bodyDelegate.destroy()},r.prototype.open=function(){if(this.target.classList.contains("o-drawer-open"))return this;this.trigger=document.activeElement;var e=this.trigger,t=this.target,o=this.firstFocusable;return t.style.display="block",t.classList.contains("o-drawer-animated")?setTimeout(function(){i(t,e,o)},50):i(t,e,o),this.bound=this.trapFocus.bind(this),t.addEventListener("keydown",this.bound),this.currentTarget=!0,t.classList.contains("o-drawer-right")&&d(t,"o.Drawer.RightDrawer"),t.classList.contains("o-drawer-left")&&d(t,"o.Drawer.LeftDrawer"),d(t,"oDrawer.open"),this},r.prototype.close=function(){if(!this.target.classList.contains("o-drawer-open"))return this.trigger=document.activeElement,this;this.target.classList.remove("o-drawer-open"),d(this.target,"oDrawer.close"),this.trigger&&this.trigger.setAttribute("aria-expanded","false");var e=this.target,t=a(document.activeElement,e);return e.classList.contains("o-drawer-animated")?setTimeout(function(){e.style.display="none"},400):e.style.display="none",e.removeEventListener("keydown",this.bound),t&&this.trigger&&this.trigger.focus(),this},r.prototype.toggle=function(){var e=this.target.classList.contains("o-drawer-open");return e&&this.close()||this.open(),this},r.prototype.trapFocus=function(e){function t(){n===i&&(r.preventDefault(),a.focus())}function o(){n===a&&(r.preventDefault(),i.focus())}var r=e||event,n=document.activeElement,i=this.trap,a=this.firstFocusable,s=r.keyCode;switch(s){case 27:this.close();break;case 9:if(1===this.focusables.length){r.preventDefault();break}return r.shiftKey?o():t()}},e.exports=r},function(e,t,o){"use strict";e.exports=o(7)},function(e,t){/**
	 * @license
	 * Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
	 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
	 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
	 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
	 * Code distributed by Google as part of the polymer project is also
	 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
	 */
!function(t){var o=Object.defineProperty,r=Date.now()%1e9,n=function(){this.name="__st"+(1e9*Math.random()>>>0)+(r++ +"__")};n.prototype={set:function(e,t){var r=e[this.name];return r&&r[0]===e?r[1]=t:o(e,this.name,{value:[e,t],writable:!0}),this},get:function(e){var t;return(t=e[this.name])&&t[0]===e?t[1]:void 0},delete:function(e){var t=e[this.name];return!(!t||t[0]!==e)&&(t[0]=t[1]=void 0,!0)},has:function(e){var t=e[this.name];return!!t&&t[0]===e}},e.exports=(t||{}).WeakMap||n}(this||window)},function(e,t,o){t=e.exports=o(1)(),t.push([e.id,'.o-drawer{position:fixed;background-color:#e9e9e9;box-shadow:-1px 0 8px rgba(0,0,0,.3);overflow-x:hidden;overflow-y:auto;height:100%;width:332px;z-index:995}.o-drawer.o-drawer-animated{transition:left .4s ease,right .4s ease}.o-drawer.o-drawer-left,.o-drawer.o-drawer-right{top:0}.o-drawer.o-drawer-right{right:-332px}.o-drawer.o-drawer-right.o-drawer-open{right:0}.o-drawer.o-drawer-left{left:-332px}.o-drawer.o-drawer-left.o-drawer-open{left:0}.o-drawer .pe-trap{width:0;height:0;padding:0;opacity:0}@media only screen and (max-width:415px){.o-drawer{width:100%;z-index:995}.o-drawer.o-drawer-right{right:-100%}.o-drawer.o-drawer-left{left:-100%}}.o-contextual-help__drawer{color:#333;font-size:16px}.o-contextual-help__content--visible .o-contextual-help__topics{left:-100%}.o-contextual-help__content--visible .o-contextual-help__topic-content{left:0}.o-contextual-help__header{padding:19px;border-bottom:1px solid #e8e8e8;overflow:hidden}.o-contextual-help__topic-content,.o-contextual-help__topics{height:100%;width:100%;position:absolute;top:0;left:0;padding-top:48px;overflow-x:hidden;overflow-y:auto;box-sizing:border-box;transition:left .4s ease;user-select:none}.o-contextual-help__topic-content .o-panel--closed,.o-contextual-help__topics .o-panel--closed{display:none}.o-contextual-help__topic-content .o-panel--opened,.o-contextual-help__topics .o-panel--opened{display:block}.o-contextual-help__topic{padding:10px 19px;border-bottom:1px solid #e8e8e8}.o-contextual-help__topic h1,.o-contextual-help__topic h2,.o-contextual-help__topic h3,.o-contextual-help__topic h4{font-size:18px;line-height:1.45em;font-weight:400;margin-bottom:6px;margin-top:6px}.o-contextual-help__topic p{font-size:.9em;line-height:1.6em}.o-contextual-help__topic-content{left:100%}.o-contextual-help__topic-content ul{padding-left:40px}#contextual-help-close-content{color:#333}.o-contextual-help__excerpt p{height:3em;overflow:hidden}.o-contextual-help__excerpt p:after{content:"\\2026"}.back-to-help,.close-help,.o-disclosure{padding:0;background-color:transparent;border:0}.back-to-help:focus,.close-help:focus,.o-disclosure:focus{outline:1px dotted #333}.close-help{float:right}.back-to-help{float:left}.back-to-help span{margin-right:.3em}',""])},function(e,t,o){t=e.exports=o(1)(),t.push([e.id,".o-drawer{position:fixed;background-color:#ffffff;box-shadow:-1px 0 8px rgba(0,0,0,.3);overflow-x:hidden;overflow-y:auto;height:100%;width:332px;z-index:995}.o-drawer.o-drawer-animated{transition:left .4s ease,right .4s ease}.o-drawer.o-drawer-left,.o-drawer.o-drawer-right{top:0}.o-drawer.o-drawer-right{right:-332px}.o-drawer.o-drawer-right.o-drawer-open{right:0}.o-drawer.o-drawer-left{left:-332px}.o-drawer.o-drawer-left.o-drawer-open{left:0}.o-drawer .pe-trap{width:0;height:0;padding:0;opacity:0}@media only screen and (max-width:415px){.o-drawer{width:100%;z-index:995}.o-drawer.o-drawer-right{right:-100%}.o-drawer.o-drawer-left{left:-100%}}",""])},function(e,t){"use strict";function o(e){this.listenerMap=[{},{}],e&&this.root(e),this.handle=o.prototype.handle.bind(this)}function r(e,t){return e.toLowerCase()===t.tagName.toLowerCase()}function n(e,t){return this.rootElement===window?t===document:this.rootElement===t}function i(e,t){return e===t.id}e.exports=o,o.prototype.root=function(e){var t,o=this.listenerMap;if(this.rootElement){for(t in o[1])o[1].hasOwnProperty(t)&&this.rootElement.removeEventListener(t,this.handle,!0);for(t in o[0])o[0].hasOwnProperty(t)&&this.rootElement.removeEventListener(t,this.handle,!1)}if(!e||!e.addEventListener)return this.rootElement&&delete this.rootElement,this;this.rootElement=e;for(t in o[1])o[1].hasOwnProperty(t)&&this.rootElement.addEventListener(t,this.handle,!0);for(t in o[0])o[0].hasOwnProperty(t)&&this.rootElement.addEventListener(t,this.handle,!1);return this},o.prototype.captureForType=function(e){return["blur","error","focus","load","resize","scroll"].indexOf(e)!==-1},o.prototype.on=function(e,t,o,s){var l,c,p,u;if(!e)throw new TypeError("Invalid event type: "+e);if("function"==typeof t&&(s=o,o=t,t=null),void 0===s&&(s=this.captureForType(e)),"function"!=typeof o)throw new TypeError("Handler must be a type of Function");return l=this.rootElement,c=this.listenerMap[s?1:0],c[e]||(l&&l.addEventListener(e,this.handle,s),c[e]=[]),t?/^[a-z]+$/i.test(t)?(u=t,p=r):/^#[a-z0-9\-_]+$/i.test(t)?(u=t.slice(1),p=i):(u=t,p=a):(u=null,p=n.bind(this)),c[e].push({selector:t,handler:o,matcher:p,matcherParam:u}),this},o.prototype.off=function(e,t,o,r){var n,i,a,s,l;if("function"==typeof t&&(r=o,o=t,t=null),void 0===r)return this.off(e,t,o,!0),this.off(e,t,o,!1),this;if(a=this.listenerMap[r?1:0],!e){for(l in a)a.hasOwnProperty(l)&&this.off(l,t,o);return this}if(s=a[e],!s||!s.length)return this;for(n=s.length-1;n>=0;n--)i=s[n],t&&t!==i.selector||o&&o!==i.handler||s.splice(n,1);return s.length||(delete a[e],this.rootElement&&this.rootElement.removeEventListener(e,this.handle,r)),this},o.prototype.handle=function(e){var t,o,r,n,i,a,s,l=e.type,c=[],p="ftLabsDelegateIgnore";if(e[p]!==!0){switch(s=e.target,3===s.nodeType&&(s=s.parentNode),r=this.rootElement,n=e.eventPhase||(e.target!==e.currentTarget?3:2)){case 1:c=this.listenerMap[1][l];break;case 2:this.listenerMap[0]&&this.listenerMap[0][l]&&(c=c.concat(this.listenerMap[0][l])),this.listenerMap[1]&&this.listenerMap[1][l]&&(c=c.concat(this.listenerMap[1][l]));break;case 3:c=this.listenerMap[0][l]}for(o=c.length;s&&o;){for(t=0;t<o&&(i=c[t],i);t++)if(i.matcher.call(s,i.matcherParam,s)&&(a=this.fire(e,s,i)),a===!1)return e[p]=!0,void e.preventDefault();if(s===r)break;o=c.length,s=s.parentElement}}},o.prototype.fire=function(e,t,o){return o.handler.call(t,e,t)};var a=function(e){if(e){var t=e.prototype;return t.matches||t.matchesSelector||t.webkitMatchesSelector||t.mozMatchesSelector||t.msMatchesSelector||t.oMatchesSelector}}(Element);o.prototype.destroy=function(){this.off(),this.root()}},function(e,t,o){"use strict";/**
	 * @preserve Create and manage a DOM event delegator.
	 *
	 * @version 0.3.0
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */
var r=o(10);e.exports=function(e){return new r(e)},e.exports.Delegate=r},function(e,t){e.exports="<h2></h2> <div></div> "},function(e,t){e.exports='<div class="o-contextual-help__topic o-contextual-help__excerpt"> <h3 class="pe-label pe-label--large"> <a href=#></a> </h3> <p></p> </div> '},function(e,t){e.exports='<div class=o-contextual-help__topics> <div class=o-contextual-help__header> <button type=button data-target=#o-contextual-help-drawer data-close=o-drawer class=close-help> <i class=pe-icon--close aria-hidden=true></i> <span class=pe-sr-only>Close Help</span> </button> <h2 class="pe-label pe-label--large">Help Topics</h2> </div> <div class=o-contextual-help__excerpt-list aria-live=polite></div> </div> <div class=o-contextual-help__topic-content> <div class=o-contextual-help__header> <button type=button data-target=#o-contextual-help-drawer data-close=o-drawer class=close-help> <i class=pe-icon--close aria-hidden=true></i> <span class=pe-sr-only>Close Help</span> </button> <button type=button class="pe-label pe-label--large back-to-help" id=contextual-help-close-content> <span aria-hidden=true><i class=pe-icon--chevron-left></i></span> Back to Help Topics </button> </div> <div id=o-contextual-help-topic-content-target class=o-contextual-help__topic aria-live=polite></div> </div> '},function(e,t,o){var r=o(8);"string"==typeof r&&(r=[[e.id,r,""]]);o(2)(r,{});r.locals&&(e.exports=r.locals)},function(e,t,o){var r=o(9);"string"==typeof r&&(r=[[e.id,r,""]]);o(2)(r,{});r.locals&&(e.exports=r.locals)},function(e,t,o){"use strict";function r(e){function t(){var e={},t=document.querySelector("[data-o-contextual-help-config]");if(!t)return e;try{e=JSON.parse(t.textContent)}catch(t){throw e={},new Error("Unable to parse configuration object: invalid JSON")}return e}var o=this,r="https://help.pearsoncmg.com/csh/";this.fetchHelpContent=function(e,t){return t=t||function(){},""===e.replace(/\s/,"")&&t("no content ID issued"),o.cache&&o.cache[e]?void t(null,o.cache[e]):void n({url:r+o.lang+"/"+e+".json",onSuccess:function(r){var n=JSON.parse(r.responseText);o.cache[e]=n,t(null,n)},onError:function(i){if(o.lang!==o.defaultLang){var a=o.defaultLang;n({url:r+"/"+a+"/"+e+".json",onSuccess:function(r){var n=JSON.parse(r.responseText);o.cache[e]=n,t(null,n)},onError:function(e){t(e)}})}else t(i)}})},this.defaultLang="en-us",this.lang=this.defaultLang,e instanceof String&&(e=document.querySelector("#"+e)),this._el=e,this.cache={},this.topics=[],e.nodeType&&(e.innerHTML=i),this._inner_trigger=null,e.querySelector(".o-contextual-help__topic-content").style.visibility="hidden",e.querySelector("#contextual-help-close-content").onclick=function(){o.manageLayers(!1)};var s=t();s&&s.helpTopics&&s.helpTopics.length>0&&(this.topics=s.helpTopics),this.populateFromList=function(e,t){if(t=t||function(){},e.length>0){var r=e.splice(0,1)[0];o.fetchHelpContent(r,function(n,i){i&&!n||e.length>0&&o.populateFromList(e,t);var s=document.createElement("div");s.innerHTML=a;var l=s.querySelector("h3 a");l.innerHTML=i.title,l.onclick=function(){o._inner_trigger=l,o.openHelpTopic(r)},s.querySelector("p").innerHTML=i.excerpt,o._el.querySelector(".o-contextual-help__excerpt-list").appendChild(s),e.length>0?o.populateFromList(e,t):t()})}else t()},this._initRunning=!1,this._rerunInit=!1,this.init=function(){this._initRunning=!0,this._el.querySelector(".o-contextual-help__excerpt-list").innerHTML="";var e=this.deDupeTopics();this.populateFromList(e,function(){o._initRunning=!1,o._rerunInit&&(o._rerunInit=!1,o.init())})};var l=document.querySelector("header.o-app-header");return l&&l.addEventListener("oAppHeader.help.toggle",function(){o.toggle&&o.toggle()}),this.scheduleInit(),this._el.oContextualHelp=this,this}var n=o(18),i=o(14),a=o(13),s=o(12);r.prototype.scheduleInit=function(){this._initRunning?this._rerunInit=!0:this.init()},r.prototype.deDupeTopics=function(){var e=this.topics,t=e.filter(function(t,o){return e.indexOf(t)==o});return t},r.prototype.setLanguage=function(e){this.lang=e},r.prototype.manageLayers=function(e){var t=this._el,o=this,r=t.querySelector(".o-contextual-help__topics"),n=t.querySelector(".o-contextual-help__topic-content"),i=r.querySelector(".close-help"),a=n.querySelector(".close-help"),s=n.querySelector("#contextual-help-close-content");e?(n.style.visibility="visible",this._drawer.firstFocusable=a,t.classList.add("o-contextual-help__content--visible"),setTimeout(function(){r.style.visibility="hidden",s.focus()},450)):(r.style.visibility="visible",this._drawer.firstFocusable=i,t.classList.remove("o-contextual-help__content--visible"),setTimeout(function(){n.style.visibility="hidden",null!==o._inner_trigger?(o._inner_trigger.focus(),o._inner_trigger=null):i.focus()},450))},r.prototype.accordion=function(){for(var e=this._el.querySelector(".o-contextual-help__accordion"),t=e.querySelectorAll(".o-disclosure"),o=(e.querySelectorAll("[class^='o-panel--']"),0),r=t.length;o<r;o++){var n=t[o];n.onclick=function(e){var t=document.getElementById(this.getAttribute("aria-controls")),o=this.getElementsByTagName("I")[0];"true"==this.getAttribute("aria-expanded")?(t.className="o-panel--closed",o.className="pe-icon--caret-right",this.setAttribute("aria-expanded",!1)):(t.className="o-panel--open",o.className="pe-icon--caret-down",this.setAttribute("aria-expanded",!0))}}},r.prototype.openHelpTopic=function(e){var t=this._el.querySelector("#o-contextual-help-topic-content-target"),o=this._el;e||(t.innerHTML=""),e&&(this.fetchHelpContent(e,function(e,o){if(e)throw e;if(o){t.innerHTML=s,t.querySelector("h2").innerHTML=o.title;var r=t.querySelector("div");r.innerHTML=o.content}}),t.querySelector(".o-contextual-help__accordion")&&this.accordion()),this.manageLayers(!0),o.classList.contains("o-drawer-open")||this.open()},r.prototype.addTopics=function(e){"string"==typeof e&&(e=[e]);for(var t=0,o=e.length;t<o;t++){var r=e[t];this.topics.indexOf(r)<0&&this.topics.push(r)}this.scheduleInit()},r.prototype.removeTopics=function(e){"string"==typeof e&&(e=[e]);for(var t=0,o=e.length;t<o;t++){var r=e[t];this.topics.indexOf(r)>=0&&this.topics.splice(this.topics.indexOf(r),1)}this.scheduleInit()},r.prototype.removeAllTopics=function(){this.topics.splice(0,this.topics.length),this.scheduleInit()},r.prototype.getTopics=function(){return this.topics},e.exports=r},function(e,t){"use strict";function o(e){function t(){4===o.readyState&&(n(o.status)?e.onSuccess(o):e.onError(o))}if(0===arguments.length)throw new TypeError("Expected 1 argument, got 0");if("string"==typeof e&&(e={url:e}),!e.url)throw new TypeError("The 'url' option is required");e.method=e.method||"GET",e.onSuccess=e.onSuccess||r,e.onError=e.onError||r,e.headers=e.headers||{},e.data=e.data||"";var o=e.xhr||new XMLHttpRequest;o.open(e.method,e.url,!0),o.onreadystatechange=t;for(var i in e.headers)if(e.headers.hasOwnProperty(i)){var a=e.headers[i];o.setRequestHeader(i,a)}return o.send(e.data),o}function r(){}function n(e){return e>=200&&e<=299}e.exports=o}]);
/*
 *   PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *    Copyright © 2017. Pearson Education, Inc.
 *    All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains
 *   the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *   herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *   patent applications, and are protected by trade secret or copyright law.
 *   Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *   is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 */

SocketExperienceNamespace.Adapter.PendoAnalyticsAdapter = (function ($) {

	var initializePendo = function (getDataModel, isErrorPage) {
		loadPendoScript("73a611a9-ac00-4aff-5699-0e400605bf6c");
		var pendoObj = constructPendoDataModelFromLaunchContext(getDataModel, isErrorPage);
		pendo.initialize({
			apiKey: "73a611a9-ac00-4aff-5699-0e400605bf6c",
			disableCookies: true,
			// analytics: { excludeEvents: ['load', 'click', 'focus', 'submit', 'change', 'track'] },
			visitor: {
				// GENERAL FIELDS
				id: pendoObj.userId, // Required if using visitor level data
				platform: pendoObj.platform, // Mandatory
				userRole: pendoObj.userRole,
				bookId: pendoObj.bookId,
				bookCode: pendoObj.bookCode,
				discipline: pendoObj.discipline,
				courseId: pendoObj.courseId,
				courseCreateDatetime: pendoObj.courseCreateDatetime,
				courseStartDatetime: pendoObj.courseStartDatetime,
				courseEndDatetime: pendoObj.courseEndDatetime,
				userAnalyticsConsent: pendoObj.userAnalyticsConsent,
				languageCode: pendoObj.languageCode,
				userCountryCode: pendoObj.userCountryCode,
				integrationType: pendoObj.integrationType,
				LMSName: pendoObj.lmsName,
				//SOCKET SPECIFIC
				LTI_version: pendoObj.ltiVersion,
				courseLicenseType: pendoObj.courseLicenseType,
				integrationModel: pendoObj.integrationModel,
				launchType: pendoObj.launchType,
				courseProvisioningType: pendoObj.courseProvisioningType,
				channelPartner: pendoObj.channelPartner,
				socketErrorCode: pendoObj.errorCode
			},
			account: {
				// ACCOUNT SPECIFIC
				id: pendoObj.organizationId, // Required if using account level data
				name: pendoObj.organizationName,
				orgCountryCode: pendoObj.orgCountryCode
			},
		});
	};

	var loadPendoScript = function (apiKey) {
		(function (p, e, n, d, o) {
			var v, w, x, y, z;
			o = p[d] = p[d] || {};
			o._q = o._q || [];

			v = ["initialize", "identify", "updateOptions", "pageLoad", "track"];
			for (w = 0, x = v.length; w < x; ++w)
				(function (m) {
					o[m] =
						o[m] ||
						function () {
							o._q[m === v[0] ? "unshift" : "push"](
								[m].concat([].slice.call(arguments, 0))
							);
						};
				})(v[w]);

			y = e.createElement(n);
			y.async = !0;
			y.src = "https://cdn.pendo.io/agent/static/" + apiKey + "/pendo.js";

			z = e.getElementsByTagName(n)[0];
			z.parentNode.insertBefore(y, z);
		})(window, document, "script", "pendo");
	};

	var constructPendoDataModelFromLaunchContext = function (getDataModel, isErrorPage) {
		var dataModel = getDataModel();
		var launchContext = dataModel.launchContext;

		//SPECIFICALLY FOR ERROR PAGE WITHOUT LAUNCHCONTEXT TOKEN
		if (typeof launchContext === "undefined") {
			var emptyLaunchContextPendoDataModel = {};
			emptyLaunchContextPendoDataModel.errorCode = dataModel.errorCode;
			return emptyLaunchContextPendoDataModel;
		}

		//SPECIFICALLY FOR K12 FLOW
		if (launchContext.external.isK12 != null) {
			var k12PendoDataModel = {
				// GENERAL FIELDS
				userId: launchContext.external.primaryIESUserId, // Mandatory
				platform: "Socket",
				userRole: getUserRole(launchContext.external.external_system_user_role),
				userAnalyticsConsent: false,
				lmsName: launchContext.external.external_system,
				// ACCOUNT SPECIFIc
				organizationId: launchContext.external.organization, // Mandatory
			};
			//SPECIFICALLY FOR ERROR PAGE K12 FLOW
			if (isErrorPage) {
				k12PendoDataModel.errorCode = launchContext.external.error_code;
			}
			return k12PendoDataModel;
		}

		//SPECIFICALLY FOR LMS CASE
		var pendoDataModel = {
			// GENERAL FIELDS
			userId: launchContext.external.primaryIESUserId, // Mandatory
			platform: "Socket",
			userRole: getUserRole(launchContext.external.external_system_user_role),
			// bookId : '',
			// bookCode: '',
			// discipline: '',
			courseId: launchContext.external.internal_course_id,
			// courseCreateDatetime: pendoObj.courseCreateDatetime,
			courseStartDatetime: launchContext.external.startDate,
			courseEndDatetime: launchContext.external.endDate,
			userAnalyticsConsent: false,
			// languageCode: '',
			// userCountryCode: '',
			integrationType: launchContext.external.socketIntegrationType,
			lmsName: launchContext.external.external_system,
			// SOCKET SPECIFIC
			ltiVersion: launchContext.external.lti_version,
			courseLicenseType: getCourseLicenseType(launchContext.external.isCPG),
			//integrationModel: launchContext.external.socketIntegrationType,
			launchType: getLaunchType(launchContext.external.is_course_paired, launchContext.external.isDeepLinkingFlow),
			courseProvisioningType: getCourseProvisioningType(launchContext.external.internal_source_course_id, launchContext.external.external_system_parent_course_id),
			channelPartner: launchContext.external.custom_channel_partner_name,
			// ACCOUNT SPECIFIC
			organizationId: launchContext.external.organization, // Mandatory
			organizationName: launchContext.organizationName
			// orgCountryCode: ''
		}
		//SPECIFICALLY FOR ERROR PAGE LMS CASE
		if (isErrorPage) {
			pendoDataModel.errorCode = launchContext.external.error_code;
		}
		return pendoDataModel;

	};

	var getUserRole = function (externalSystemUserRole) {
		if (externalSystemUserRole == null) {
			return externalSystemUserRole;
		}
		if (externalSystemUserRole.toLowerCase().includes("instructor") || externalSystemUserRole.toLowerCase().includes("teacher")) {
			return "instructor";
		}
		return externalSystemUserRole.toLowerCase();
	}

	var getCourseLicenseType = function (isCPG) {
		if (isCPG !== null) {
			if (isCPG) {
				return "IA";
			}
			return "standard";
		}
		return undefined;
	}

	var getLaunchType = function (isCoursePaired, isDeepLinkingFlow) {
		if (!isCoursePaired) {
			return "provisioning course";
		}
		if (isDeepLinkingFlow == null) {
			return "course launch";
		}
		if (!isDeepLinkingFlow) {
			return "course launch"
		}
		return "deeplink launch";
	}

	var getCourseProvisioningType = function (internalSourceCourseId, externalSystemParentCourseId) {
		if (internalSourceCourseId == null) {
			return "create course";
		}
		if (internalSourceCourseId.trim().length != 0) {
			if (externalSystemParentCourseId == null) {
				return undefined;
			}
			if (externalSystemParentCourseId.trim().length != 0) {
				return "LMS copy course";
			}
			return "copy course";
		}
		return undefined;
	}

	return {
		"initializePendo": initializePendo
	};

})(jQuery);